import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseApi } from '../../core/base/base-api';

import { LocalPartner } from './local-partner';

@Injectable({
  providedIn: 'root',
})
export class LocalPartnerApi extends BaseApi<LocalPartner> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'localpartners');
  }

  create(): LocalPartner {
    return new LocalPartner();
  }

  findByCountry(countryUuid: string): Observable<LocalPartner[]> {
    return this.httpClient.get<LocalPartner[]>(`${this.endpoint}/by-country/${countryUuid}`);
  }

  mine(): Observable<LocalPartner[]> {
    return this.httpClient.get<LocalPartner[]>(`${this.endpoint}/mine`);
  }

  nameValid(localPartner: LocalPartner): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.endpoint}/validate-name`, localPartner);
  }
}
